package com.mps.asc_app.ui.components

import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.outlined.AdminPanelSettings
import androidx.compose.material.icons.outlined.CalendarMonth
import androidx.compose.material.icons.outlined.Person
import androidx.compose.material.icons.outlined.SportsTennis
import androidx.compose.material3.Badge
import androidx.compose.material3.BadgedBox
import androidx.compose.material3.Icon
import androidx.compose.material3.NavigationBar
import androidx.compose.material3.NavigationBarItem
import androidx.compose.material3.NavigationBarItemDefaults
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.vector.ImageVector
import com.mps.asc_app.ui.theme.AscMuted
import com.mps.asc_app.ui.theme.AscNavy
import com.mps.asc_app.ui.theme.AscNavyInk
import com.mps.asc_app.ui.theme.PrimaryContainer

/** Hauptbereiche der App, erreichbar über die Navigation unten (Redesign Stufe 2). */
enum class AppTab(val label: String, val icon: ImageVector) {
    BOOKING("Buchen", Icons.Outlined.CalendarMonth),
    MY_GAMES("Meine Spiele", Icons.Outlined.SportsTennis),
    PROFILE("Profil", Icons.Outlined.Person),
    ADMIN("Admin", Icons.Outlined.AdminPanelSettings),
}

/** Admin erscheint nur für Admins. */
fun visibleTabs(isAdmin: Boolean): List<AppTab> =
    AppTab.entries.filter { it != AppTab.ADMIN || isAdmin }

@Composable
fun AscBottomBar(
    selected: AppTab,
    isAdmin: Boolean,
    onSelect: (AppTab) -> Unit,
    modifier: Modifier = Modifier,
    myGamesCount: Int = 0,
) {
    NavigationBar(modifier = modifier, containerColor = Color.White) {
        visibleTabs(isAdmin).forEach { tab ->
            NavigationBarItem(
                selected = tab == selected,
                onClick = { onSelect(tab) },
                icon = {
                    if (tab == AppTab.MY_GAMES && myGamesCount > 0) {
                        BadgedBox(badge = { Badge { Text(myGamesCount.toString()) } }) {
                            Icon(tab.icon, contentDescription = null)
                        }
                    } else {
                        Icon(tab.icon, contentDescription = null)
                    }
                },
                label = { Text(tab.label) },
                colors = NavigationBarItemDefaults.colors(
                    selectedIconColor = AscNavyInk,
                    selectedTextColor = AscNavy,
                    indicatorColor = PrimaryContainer,
                    unselectedIconColor = AscMuted,
                    unselectedTextColor = AscMuted,
                ),
            )
        }
    }
}
